import React, { useState } from "react";
import emailjs from "emailjs-com";

function ContactTwo() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    subject: "",
    message: "",
  });

  const [status, setStatus] = useState("idle"); 
  // idle | submitting | success | error

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus("submitting");

    emailjs
      .send(
        "service_czipkze",   // e.g. service_xxxxxx
        "template_3qhkoqg",  // e.g. template_xxxxxx
        formData,
        "WiADnDeJhy4AdyVMR"       // e.g. v2iA0xxxxxxxx
      )
      .then(
        () => {
          console.log("SUCCESS!");
          setStatus("success");
          setFormData({
            name: "",
            phone: "",
            email: "",
            subject: "",
            message: "",
          });
        },
        (err) => {
          console.log("FAILED...", err);
          setStatus("error");
        }
      );
  };

  return (
    <div>
      <div className="contact-area contact-bg-1 bg_image tmp-section-gap">
        <div className="container">
          <div className="row">
            {/* Left Side */}
            <div className="col-lg-5">
              <div className="contact-inner">
                <div className="section-head section-head-one-side text-align-left">
                  <h2 className="title split-collab">
                    Get free <br />
                    consultation today
                  </h2>
                  <p className="description mt--30">
                    Get your free consultation today and discover how our
                    experts can help your business grow with smart, tailored
                    financial solutions.
                  </p>
                </div>
                <ul className="ft-link ft-link-style-two">
                  <li>
                    <div className="single-contact background-transparent">
                      <div className="icon">
                        <i className="fa-light fa-phone" />
                      </div>
                      <div className="content">
                        <span>Call Us</span>
                        <a className="contact-here" href="tel:8323510418">
                          832-351-0418
                        </a>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="single-contact background-transparent">
                      <div className="icon">
                        <i className="fa-solid fa-envelope-open-text" />
                      </div>
                      <div className="content">
                        <span>E-mail</span>
                        <a
                          className="contact-here"
                          href="mailto:info@anbsllc.com"
                        >
                          info@anbsllc.com
                        </a>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="single-contact background-transparent">
                      <div className="icon">
                        <i className="fa-regular fa-map-location-dot" />
                      </div>
                      <div className="content">
                        <span>Address</span>
                        <a
                          className="contact-here"
                          href="https://maps.app.goo.gl/DSKjbb24qTxyMEPE7"
                        >
                          16314 Amber Brown Drive, Hockley, TX 77447
                        </a>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            {/* Right Side – Form */}
            <div className="col-lg-7 mt_md--50 mt_sm--50">
              <div className="contact-form">
                <div className="section-head section-head-one-side text-align-left">
                  <span className="subtitle">GET IN TOUCH</span>
                </div>
                <div id="form-messages" />
                <form id="contact-form" onSubmit={handleSubmit}>
                  <div className="contact-form-wrapper row">
                    <div className="col-lg-6">
                      <div className="form-group">
                        <input
                          className="input-field"
                          name="name"
                          placeholder="Name"
                          id="contact-name"
                          type="text"
                          value={formData.name}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <input
                          className="input-field"
                          name="phone"
                          placeholder="Phone"
                          type="tel"
                          value={formData.phone}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <input
                          className="input-field"
                          name="email"
                          placeholder="Email"
                          type="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <input
                          className="input-field"
                          name="subject"
                          placeholder="Subject"
                          type="text"
                          value={formData.subject}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-group">
                        <textarea
                          className="input-field"
                          name="message"
                          placeholder="How can we help"
                          value={formData.message}
                          onChange={handleChange}
                          required
                          id="contact-message"
                        />
                      </div>
                    </div>

                    <div className="col-lg-12">
                      <div className="form-submit-group">
                        {status === "success" ? (
                          <p className="form-success-message">
                            Submitted successfully. We will contact you shortly.
                          </p>
                        ) : (
                          <button
                            className="tmp-btn btn-primary button-custom"
                            type="submit"
                            disabled={status === "submitting"}
                          >
                            {status === "submitting"
                              ? "Submitting..."
                              : "Submit Now"}
                          </button>
                        )}

                        {status === "error" && (
                          <p className="form-error-message">
                            Something went wrong. Please try again.
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            {/* End Right Col */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactTwo;


